var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main555555555"},[_c('iframe',{attrs:{"id":"1","src":_vm.dtssrc,"width":"100%","height":"100%","scrolling":"no","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }